import * as yup from "yup";
import {
  OffsetUnit,
} from "models/automation";
import { ReminderReferenceEvent, ReminderTriggerType } from "./models";

const reminderTriggerDataSchema = yup.object({ // eslint-disable-line @typescript-eslint/no-unused-vars
  referenceEvent: yup.mixed<ReminderReferenceEvent>().required().label("Event"),
  offset: yup.number().required().integer().label("Offset"),
  offsetUnit: yup
    .mixed<OffsetUnit>()
    .label("Day/Week/Month")
    .when("offset", {
      is: (value: number) => value !== 0,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable()
        .test(
          "must-be-null",
          "Unit must not be set when offset is 0",
          (value) => value == null,
        ),
    }),
});

export type ReminderTriggerData = yup.InferType<typeof reminderTriggerDataSchema>;

export const reminderTriggerSchema = yup.object({
  type: yup.string<ReminderTriggerType>().required().nonNullable(),
  data: yup.mixed<ReminderTriggerData>().required().nonNullable(),
}).defined().nonNullable();

export type ReminderTriggerSchema = yup.InferType<typeof reminderTriggerSchema>;
